import { ReactNode, useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import { Header } from './Header';
import SessionDebugInfo from '../SessionDebugInfo';

type LayoutProps = {
  children: ReactNode;
};

const Layout = ({ children }: LayoutProps) => {
  const [showDebugInfo, setShowDebugInfo] = useState(false);

  // Toggle debug panel with keyboard shortcut (Ctrl + Shift + D)
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && e.shiftKey && e.key === 'D') {
        e.preventDefault();
        setShowDebugInfo(prev => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />

      <div className="flex-1 flex flex-col ml-0 lg:ml-64">
        <Header />

        <main className="flex-1 p-4 lg:p-6 overflow-auto no-scrollbar">
          <div className="w-full max-w-7xl mx-auto no-scrollbar">
            {children}
          </div>
        </main>
      </div>

      {/* Debug panel (Ctrl + Shift + D) */}
      <SessionDebugInfo isVisible={showDebugInfo} />
    </div>
  );
};

export default Layout;
